export default __webpack_public_path__ + "static/media/menu_back.bd349f99.jpg";